export function jsonParseSafe<T = unknown>(data: string) {
  let result;
  try {
    result = JSON.parse(data);
  } catch {
    return;
  }
  return result as T;
}
